var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { toggleModal, appMessage } from '../../Actions';
const requestNotification = (id) => ({
    type: 'NOTIFICATION_REQUESTED',
    id
});
const receivedNotifications = (notifications) => ({
    type: 'NOTIFICATION_RECEIVED',
    notifications
});
const notificationDispatched = (id, action) => ({
    type: 'NOTIFICATION_DISPATCHED',
    itemId: id,
    action
});
const actionNotificationToggle = (item) => ({
    type: 'NOTIFICATION_TOGGLE',
    item
});
export const toggleNotificationList = () => ({ type: 'NOTIFICATION_LIST_TOGGLE' });
/**
 * Do a request to the backend to mark a notification as read.
 *
 * @param {number} id
 */
const markNotificationAsRead = (id) => axios.get(`/api/notifications/mark-as-read/${id}`);
/**
 * Toggle a notification in a modal, and mark it as read.
 *
 * @param {object} item
 *
 * @return {function(*)}
 */
export function toggleNotification(item) {
    return (dispatch) => {
        dispatch(actionNotificationToggle(item));
        dispatch(toggleModal('notification'));
        // Mark the notification as read, but only if actions is not required.
        if (!item.is_read && !item.action_key) {
            markNotificationAsRead(item.id);
        }
    };
}
export function fetchNotification(id) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        dispatch(requestNotification(id));
        const response = yield axios.get(`/api/notifications/${id}`);
        dispatch(toggleNotification(response.data));
    });
}
/**
 * Fetch notifications from backend.
 */
export function fetchNotifications() {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get('/api/notifications');
        if (Object.prototype.toString.call(response.data) === '[object Array]') {
            dispatch(receivedNotifications(response.data));
        }
    });
}
/**
 * Dispatch an answer to a notification.
 *
 * @param {number} id
 *   The ID of the notification to respond to.
 * @param {boolean} accept
 *   The answer.
 *
 * @returns {function}
 *   A promise.
 */
export function dispatchNotificationAction(id, accept) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        const actionType = accept ? '1' : '0';
        const data = new FormData();
        data.append('action', actionType);
        try {
            let response = yield axios.post(`/api/notifications/${id}/dispatch`, data);
            yield dispatch(notificationDispatched(id, accept));
            yield markNotificationAsRead(id);
            if (response.data === 'redirect') {
                return 'redirect';
            }
        }
        catch (error) {
            if (error.response && error.response.status === 417) {
                dispatch(appMessage(error.response.data));
                dispatch(toggleModal());
            }
            return false;
        }
        return true;
    });
}
